import {UnifiedLayoutWithRouter} from '@stubhub/react-unified-app';
import './layout.scss';

export default UnifiedLayoutWithRouter;
